module.exports = __webpack_public_path__ + "static/media/integrationIcon.c4b637a4.svg";